export default __webpack_public_path__ + "static/data_b.daaffde2aa7706a5c5b44cfad0d46600.png";